import { EmployeeSection } from '../../components/EmployeeSection';
import { Select } from '@welbe/design-system';
import { Controller } from 'react-hook-form';
import { useEmployee } from '../../Employee.hooks';
import { useEffect, useState } from 'react';
import { getJobProfiles } from '../../Employee.services';

export const JobProfile = ({ disabled }: { disabled?: boolean }) => {
	const { methods } = useEmployee();
	const { control } = methods;
	const [riskProfileOptions, setRiskProfilesOptions] = useState([]);
	const [exposureAreaOptions, setExposureAreaOptions] = useState([]);
	const [loading, setLoading] = useState(false);

	const fetchJobProfiles = async () => {
		try {
			setLoading(true);
			const { data } = await getJobProfiles();
			setRiskProfilesOptions(data?.content?.riskProfiles || []);
			setExposureAreaOptions(data?.content?.expositionAreas || []);
		} catch (error) {
			console.error('Error fetching job profiles:', error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchJobProfiles();
	}, []);

	return (
		<EmployeeSection
			id="position-profile"
			title="Perfil de puesto"
			description="Registra si el puesto de este colaborador tiene riesgo laboral o desarrolla sus actividades en un área de exposición"
		>
			<Controller
				name="riskProfiles"
				control={control}
				render={({ field }) => {
					return (
						<Select.Snippet
							loading={loading}
							disabled={disabled}
							options={riskProfileOptions}
							label="Perfil de riesgo"
							multiple
							placeholder="Seleccione una opción"
							value={field.value ? field.value : undefined}
							onValueChange={(value: any) => {
								field.onChange(value ? value.map((item: any) => item.id) : []);
							}}
						/>
					);
				}}
			/>
			<Controller
				name="expositionAreas"
				control={control}
				render={({ field }) => (
					<Select.Snippet
						loading={loading}
						disabled={disabled}
						options={exposureAreaOptions}
						label="Área de exposición"
						placeholder="Seleccione una opción"
						value={field.value ? field.value : undefined}
						onValueChange={(value: any) => {
							field.onChange(value ? [value.id] : []);
						}}
					/>
				)}
			/>
		</EmployeeSection>
	);
};
